import { render } from "./AutoTest.vue?vue&type=template&id=ea5b9854&scoped=true&ts=true"
import script from "./AutoTest.vue?vue&type=script&lang=ts"
export * from "./AutoTest.vue?vue&type=script&lang=ts"

import "./AutoTest.vue?vue&type=style&index=0&id=ea5b9854&scoped=true&lang=css"
import "./AutoTest.vue?vue&type=style&index=1&id=ea5b9854&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5b9854"]])

export default __exports__